const SafetyRegulationsPart2 = () => {
  return (
    <>
      <h2>Førerkort/førerrett</h2>
      <ul>
        <li>
          – Bilens fører skal ha de førerkort, kjøresedler, bevis, sertifikater
          og attester myndighetene krever for den klasse og brukstype bilen
          tilhører.
        </li>
        <li>
          – Fører over 80 år med førerkort i klasse A, A1, A2, AM, B, B1, BE, S
          og T, skal ha helseattest, jf. Førerkortforskriftene § 6.
        </li>
      </ul>
      <p>
        Den som er registrert eier plikter å påse at fører/bruker av bilen
        overholder ovennevnte regler.
      </p>
      <h2>Vognkort</h2>
      <p>
        Vognkortets Del 2 skal oppbevares adskilt fra bilen og på en slik måte
        at det ikke kan benyttes av uvedkommende. Tap av vognkort skal
        umiddelbart meldes til trafikkstasjonen.
      </p>
      <h2>Øvelseskjøring</h2>
      <p>
        Under øvelseskjøring skal elev og ledsager oppfylle gjeldende
        bestemmelser fastsatt i lov/forskrift om lovlig øvelses kjøring.
      </p>
      <h2>Utrusting, overbelastning og vedlikehold</h2>
      <p>
        Bilen skal være utrustet slik at den er i trafikksikker stand. Gods skal
        sikres forsvarlig. Den skal ikke overbelastes, og behandling og
        vedlikehold av bilen skal skje i henhold til fabrikantens/leverandørens
        anbefalinger og i henhold til gjeldende bestemmelser i lov/forskrift.
        Bilens væskekjølesystem skal være påfylt frosthindrende middel tilpasset
        de klimatiske forhold. Fabrikantens serviceintervaller skal overholdes.
      </p>
      <h2>Utgifter til rettsbehandling</h2>
      <p>
        Sikrede skal ved eventuell dekning av utgifter til sakkyndige som ikke
        er oppnevnt av retten, innhente forhåndsgodkjennelse av selskapet.
      </p>
      <h2>Saksomkostninger ved forlik</h2>
      <p>
        Sikrede skal ved eventuell inngåelse av avtale om saksomkostninger ved
        forlik, innhente forhåndsgodkjennelse av selskapet.
      </p>
      <h2>Nøkler</h2>
      <ul>
        <li>
          Nøkler skal oppbevares adskilt fra bilen når denne forlates, og på en
          slik måte at de ikke kan benyttes av uvedkommende.
        </li>
        <li>
          Eier eller rettmessig bruker skal ha tilsyn med nøkler som ikke er i
          bruk, eller sørge for at disse er innelåst i bygning eller rom i
          bygning.
        </li>
        <li>
          Biler med elektronisk startsperre skal uten unødig opphold få denne
          omprogrammert, dersom nøkler er kommet på avveie.
        </li>
      </ul>
    </>
  );
};

export default SafetyRegulationsPart2;
